import get from 'lodash.get';
import { format } from 'date-fns';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { selectPayrollExportsKeyedById } from 'services/payrollExports/selectors';
import { OwnProps } from './index';

const selectPayrollExportId = (state: AppState, props: OwnProps): number =>
    props.id;

const selectSubmittedAt = createDeepEqualSelector(
    selectPayrollExportId,
    selectPayrollExportsKeyedById,
    (payrollExportId, payrollExportsKeyedById) => {
        const createdAt = get(payrollExportsKeyedById, [
            payrollExportId,
            'createdAt'
        ]);

        return format(new Date(createdAt), 'dd/MM/yyyy');
    }
);

const makeSelectSubmittedAt = (): typeof selectSubmittedAt => selectSubmittedAt;

export { selectPayrollExportId, makeSelectSubmittedAt };
